// extracted by mini-css-extract-plugin
export default {"team-card":"TeamCard_team-card__MRSkG","pic":"TeamCard_pic__+31ow","social":"TeamCard_social__lkjD-","info":"TeamCard_info__Zw2qL"};